import React from 'react';
import PropTypes from 'prop-types';

/* eslint-disable max-len */
const Bowling = (props) => {
  const { height, width, fill, className } = props;
  return (
    <svg
      id="bowling"
      width={width}
      height={height}
      fill={fill}
      stroke="none"
      className={className}
      viewBox="0 0 25 25"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M16.5156 13.2344C13.8232 13.2344 11.6328 15.4248 11.6328 18.1172C11.6328 20.8096 13.8232 23 16.5156 23C19.208 23 21.3984 20.8096 21.3984 18.1172C21.3984 15.4248 19.208 13.2344 16.5156 13.2344ZM16.7109 18.5078C16.3873 18.5078 16.125 18.2455 16.125 17.9219C16.125 17.5983 16.3873 17.3359 16.7109 17.3359C17.0345 17.3359 17.2969 17.5983 17.2969 17.9219C17.2969 18.2455 17.0345 18.5078 16.7109 18.5078ZM17.4922 15.9688C17.4922 15.6452 17.7545 15.3828 18.0781 15.3828C18.4017 15.3828 18.6641 15.6452 18.6641 15.9688C18.6641 16.2923 18.4017 16.5547 18.0781 16.5547C17.7545 16.5547 17.4922 16.2923 17.4922 15.9688ZM19.0547 18.5078C18.7311 18.5078 18.4688 18.2455 18.4688 17.9219C18.4688 17.5983 18.7311 17.3359 19.0547 17.3359C19.3783 17.3359 19.6406 17.5983 19.6406 17.9219C19.6406 18.2455 19.3783 18.5078 19.0547 18.5078Z" />
      <path d="M6.50239 7.77266L9.09379 9.58914L11.6852 7.77266L11.9625 6.77566C12.2141 5.87117 12.0327 4.92371 11.4647 4.17621C10.8967 3.42871 10.0326 3 9.09379 3C8.155 3 7.29086 3.42871 6.7229 4.17621C6.15489 4.92371 5.97348 5.87117 6.22504 6.77566L6.50239 7.77266Z" />
      <path d="M9.09389 11.9695L11.4217 10.6066C11.3344 10.2327 11.3001 9.8466 11.32 9.45984L9.43025 10.7845C9.32928 10.8553 9.21158 10.8907 9.09393 10.8907C8.97627 10.8907 8.85857 10.8553 8.7576 10.7845L6.86783 9.45984C6.88771 9.8466 6.85342 10.2327 6.76611 10.6066L9.09389 11.9695Z" />
      <path d="M12.7617 13.3701C12.5383 12.8563 12.2728 12.3609 11.9667 11.8891C11.9667 11.8891 11.9667 11.8891 11.9667 11.8891C11.9284 11.8302 11.8919 11.7703 11.8569 11.7097L9.38976 13.1541C9.29831 13.2076 9.19601 13.2344 9.0937 13.2344C8.9914 13.2344 8.88909 13.2076 8.79765 13.1541L6.3305 11.7097C6.29554 11.7703 6.25898 11.8302 6.22073 11.8891C5.22718 13.4205 4.66937 15.1618 4.60749 16.9248C4.51144 19.6626 5.60472 21.742 6.26499 22.7379C6.37355 22.9016 6.55691 23 6.75335 23H11.4341C11.6306 23 11.814 22.9016 11.9225 22.7378C12.0099 22.6059 12.0938 22.4709 12.1752 22.334C11.115 21.2429 10.4609 19.7551 10.4609 18.1172C10.4609 16.1954 11.361 14.48 12.7617 13.3701Z" />
    </svg>
  );
};
/* eslint-enable max-len */

Bowling.defaultProps = {
  className: null,
};

Bowling.propTypes = {
  height: PropTypes.number.isRequired,
  width: PropTypes.number.isRequired,
  fill: PropTypes.string.isRequired,
  className: PropTypes.string,
};
export default Bowling;
